<template>
  <div class="d-flex justify-content-between" v-if="allItems.length">
    <div class="text-right m-4">
      <h5 style="font-size: 1vw !important"></h5>
    </div>
    <div class="d-flex">
      <a style="margin-top: 1.3vw; margin-left: 0.5vw;" class="btn btn-primary bg-danger border-danger btn-submit-1"
         v-if="modalMessage &&  allItems.length" @click="modalMessageShowModal=true"> دلایل عدم تایید</a>
    </div>

  </div>
  <center>
    <div class="alert alert-info" style="width: 10vw;" v-if="modalMessage && !allItems.length"
         @click="modalMessageShowModal=true">دلایل عدم تایید
    </div>
    <div dir="rtl" class="modal__error slide-top" v-show="modalMessageShowModal"
         style="z-index: 999999999999999; top: 40%;">
      <div>
        <p>دلایل عدم تایید</p>
        <p @click="modalMessageShowModal=!modalMessageShowModal">❌</p>
      </div>
      <div>
        <div>
          <p>{{ modalMessageShow }}</p>
        </div>

        <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
          <button @click="modalMessageShowModal=false" class="btn btn-primary btn-back" type="submit">برگشت</button>
        </div>
      </div>
    </div>
  </center>

  <div class="filter-container">
    <div class="row">
      <div class="col-4">
        <p class="fw-bolder">فیلتر براساس وضعیت اقدام</p>
        <select class="form-select" v-model="actionStatus">
          <option value="همه">همه</option>
          <option value="مصوب">مصوب</option>
          <option value="درحال تصویب">درحال تصویب</option>
          <option value="تکمیل شده">تکمیل شده</option>
        </select>
      </div>

      <div class="col-4">
        <p class="fw-bolder">فیلتر براساس وضعیت فعالیت</p>
        <select class="form-select" v-model="activityStatus">
          <option value="همه">همه</option>
          <option value="تکمیل شده">تکمیل شده</option>
          <option value="تکمیل نشده">تکمیل نشده</option>
        </select>
      </div>

      <div class="col-4">
        <p class="fw-bolder">فیلتر براساس دوره چرخه</p>
        <select class="form-select" v-model="period">
          <option value="همه">همه</option>
          <option v-for="(event, index) in events" :key="index" :value="event.name">{{ event.name }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="table-responsive p-5" style="overflow-x:scroll; ">
    <center v-show="!allItems.length || step !== 2">
      در انتظار تکمیل / بروزرسانی کاربرگ توسط {{ $route.params.title }}
    </center>
    <center v-if="statusIsApproved">
      <div class="alert alert-success">
        تایید نهایی شرکت {{ $route.params.title }} انجام شد
      </div>
    </center>

    <center v-else-if="banBySeconder">
      <div class="alert alert-warning">
        کاربرگ توسط رئیس کمیته تایید نشد!
      </div>
    </center>

    <template v-if="(!banBySeconder || !banByApprover) && (step === 2 || step === 3)">
      <div style="overflow-y: scroll; height: 45vw;" :style="allItems.length < 5 ? 'height: auto;' : ''">
        <table class="table table-striped" v-show="allItems.length" style="width: 310vw;">
          <thead>
          <tr style="height: 1vw !important;">
            <th class="sticky-header"><strong>ردیف</strong></th>
            <th class="sticky-header sticky-column" style="width: 24vw;"><strong>مسئله</strong></th>
            <th class="sticky-header" style="width: 12vw;"><strong>سیاست مداخله</strong></th>
            <th class="sticky-header sticky-column sticky-column-two" style="width: 7vw;"><strong>اقدام پیشران</strong>
            </th>
            <th class="sticky-header" style="width: 7vw;"><strong>زمان شروع اقدام</strong></th>
            <th class="sticky-header" style="width: 7vw;"><strong>زمان پایان اقدام</strong></th>
            <th class="sticky-header sticky-column sticky-column-three" style="width: 7vw;"><strong>فعالیت‌
              کلیدی</strong>
            </th>
            <th class="sticky-header" style="width: 7vw;"><strong>دستگاه‌ همکار</strong></th>
            <th class="sticky-header" style="width: 7vw;"><strong>تاریخ شروع فعالیت</strong></th>
            <th class="sticky-header" style="width: 7vw;"><strong>تاریخ پایان فعالیت</strong></th>
            <th class="sticky-header" style="width: 5vw;"><strong>مستندات پیشرفت فعالیت‌ها</strong></th>
            <th class="sticky-header"><strong>هدف فصل بهار</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل بهار</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل بهار</strong></th>
            <th class="sticky-header"><strong>هدف فصل تابستان</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل تابستان</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل تابستان</strong></th>
            <th class="sticky-header"><strong>هدف فصل پاییز</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل پاییز</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل پاییز</strong></th>
            <th class="sticky-header"><strong>هدف فصل زمستان</strong></th>
            <th class="sticky-header"><strong>میزان پیشرفت فصل زمستان</strong></th>
            <th class="sticky-header"><strong>میزان انحراف از هدف فصل زمستان</strong></th>
            <th class="sticky-header"><strong><br>مهم‌ترین موانع عدم تحقق برنامه بهار </strong></th>
            <th class="sticky-header"><strong>راهکار پیشنهادی بهار</strong></th>
            <th class="sticky-header"><strong><br>مهم‌ترین موانع عدم تحقق برنامه تابستان</strong></th>
            <th class="sticky-header"><strong>راهکار پیشنهادی تابستان</strong></th>
            <th class="sticky-header"><strong><br>مهم‌ترین موانع عدم تحقق برنامه پاییز</strong></th>
            <th class="sticky-header"><strong>راهکار پیشنهادی پاییز</strong></th>
            <th class="sticky-header"><strong><br>مهم‌ترین موانع عدم تحقق برنامه زمستان</strong></th>
            <th class="sticky-header"><strong>راهکار پیشنهادی زمستان</strong></th>
          </tr>
          </thead>
          <tbody>
          <tr class="bg-white" v-for="(item, index) in allItems" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td class="sticky-column">{{ item.problem_name }}</td>
            <td>{{ item.basic_measures_problem }}</td>
            <td class="sticky-column sticky-column-two">{{ item.propulsion_basic_action }}</td>
            <td>{{ item.start_date_p }}</td>
            <td>{{ item.end_date_p }}</td>
            <td class="sticky-column sticky-column-three">{{ item.title }}</td>
            <td>{{ item.trustee_device }}</td>
            <td>{{ item.start_date }}</td>
            <td>{{ item.end_date }}</td>
            <td>
              <div class="d-flex align-items-center justify-content-center">
                <button @click.prevent="addDoc(item.title, item.id)" class="btn btn-primary btn-submit-1">
                  تکمیل/بروزرسانی
                </button>
              </div>
            </td>
            <td>{{ item.progress_spring }}</td>
            <td>
              <span v-if="spring"><input v-model="item.target_spring" type="text" class="form-control"></span>
              <span v-else><input disabled :value="item.target_spring" type="text" class="form-control"></span>
            </td>
            <td>{{ item.deviation_spring }}</td>
            <td>{{ item.progress_summer }}</td>
            <td>
              <span v-if="summer"><input v-model="item.target_summer" type="text" class="form-control"></span>
              <span v-else><input disabled :value="item.target_summer" type="text" class="form-control"></span>
            </td>
            <td>{{ item.deviation_summer }}</td>
            <td>{{ item.progress_autumn }}</td>
            <td>
              <span v-if="autumn"><input v-model="item.target_autumn" type="text" class="form-control"></span>
              <span v-else><input disabled :value="item.target_autumn" type="text" class="form-control"></span>
            </td>
            <td>{{ item.deviation_autumn }}</td>
            <td>{{ item.progress_winter }}</td>
            <td>
              <span v-if="winter"><input v-model="item.target_winter" type="text" class="form-control"></span>
              <span v-else><input disabled :value="item.target_winter" type="text" class="form-control"></span>
            </td>
            <td>{{ item.deviation_winter }}</td>
            <td style="width: 20vw;">
            <textarea
                v-if="spring"
                type="text"
                class="form-control"
                cols="30"
                rows="10"
                v-model="item.let_spring"

            ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.let_spring"
              ></textarea>
            </td>
            <td style="width: 20vw;">
    <textarea
        v-if="spring"
        type="text"
        class="form-control"
        cols="30"
        rows="10"
        v-model="item.solution_spring"
    ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.solution_spring"
              ></textarea>
            </td>
            <td style="width: 20vw;">
    <textarea
        v-if="summer"
        type="text"
        class="form-control"
        cols="30"
        rows="10"
        v-model="item.let"

    ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.let"
              ></textarea>
            </td>
            <td style="width: 20vw;">
    <textarea
        v-if="summer"
        type="text"
        class="form-control"
        cols="30"
        rows="10"
        v-model="item.solution"
    ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.solution"
              ></textarea>
            </td>
            <td style="width: 20vw;">
    <textarea
        v-if="autumn"
        type="text"
        class="form-control"
        cols="30"
        rows="10"
        v-model="item.let_autumn"
    ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.let_autumn"
              ></textarea>
            </td>
            <td style="width: 20vw;">
    <textarea
        v-if="autumn"
        type="text"
        class="form-control"
        cols="30"
        rows="10"
        v-model="item.solution_autumn"
    ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.solution_autumn"
              ></textarea>
            </td>
            <td style="width: 20vw;">
    <textarea
        v-if="winter"
        type="text"
        class="form-control"
        cols="30"
        rows="10"
        v-model="item.let_winter"
    ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.let_winter"
              ></textarea>
            </td>
            <td style="width: 20vw;">
    <textarea
        v-if="winter"
        type="text"
        class="form-control"
        cols="30"
        rows="10"
        v-model="item.solution_winter"
    ></textarea>
              <textarea
                  :disabled="true"
                  v-else
                  type="text"
                  class="form-control"
                  cols="30"
                  rows="10"
                  v-model="item.solution_winter"
              ></textarea>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <center v-show="allItems.length">
        <hr class="w-75 my-4">
        <button @click.prevent="store" class="btn btn-submit-1 btn-primary my-2">ذخیره</button>
      </center>
      <hr v-if="allItems.length">
      <div v-if="allItems.length" class="d-flex align-items-center justify-content-center mb-3">
        <a
            :href="`${this.download_url}/KeyActivitiesProblem/all/word/${id_route}?token=${$cookies.get('id_login')}&action_status=${actionStatus}&activity_status=${activityStatus}&period=${period}`"
           style="margin-top: 1.3vw;margin-left: 1vw;"
           class="btn btn-primary btn-submit-1">خروجی Word</a>
        <p @click.prevent="exportDocs" style="margin-left: 1vw;margin-top: 2.5vw;"
           class="btn btn-primary btn-submit-1">خروجی مستندات</p>
        <a style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw; background-color: green; border-color: green "
           class="btn btn-primary btn-submit-1 "

           @click="acceptComplete"
        >
          <div v-if="!status_loading">

            <span>  تایید </span>
          </div>
          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
        <a style="margin-top: 1.3vw;margin-left: 1vw; margin-right: 0.2vw;background-color: red; border-color: red;  "
           class="btn btn-primary btn-submit-1 "
           @click="acceptComplete2"
        >
          <div v-if="!status_loading2">
            <span>عدم تایید</span>
          </div>

          <div v-else>
            <div class="loader-line"></div>

          </div>
        </a>
      </div>
    </template>
  </div>

  <center v-show="allItems.length">
    <hr class="w-75 my-1">
  </center>
  <div class="modal__error bg-white" style="z-index: 9699; width: 54vw; overflow-y: scroll; height: 35vw;"
       v-show="documentsModal">
    <div class="d-flex justify-content-between">
      <p>{{ titleDoc }}</p>
      <p id="btn2_p" @click.prevent="documentsModal=!documentsModal">❌</p>
    </div>
    <hr>
    <div class="d-flex flex-column">
      <label class="required text-end"> عنوان مستندات پیوست </label>
      <input id="title" v-model="title_attach" type="text" class="form-control">
    </div>
    <div class="d-flex flex-column">
      <label class="required text-end"> فایل پیوست </label>
      <label class="input input--file">

        <input id="file" type="file" class="input__field"
               accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xls, .xlsx, .csv" required>
        <span class="input__support">
    <span class="input__helper"></span>
    </span>
      </label>
    </div>

    <div id="showBar" style="display:none;">
      <div class="progress">
        <div class="progress-bar" role="progressbar" id="progress_bar" :aria-valuenow="progress" aria-valuemin="0"
             aria-valuemax="100"></div>
      </div>
      <p id="progress"></p>
    </div>
    <center class="my-2">
      <button id="btn_p" @click="addDocs" class="btn btn-primary btn-submit-1">افزودن</button>
      <hr class="my-3 w-100">
    </center>
    <div v-if="!documents.length">موردی یافت نشد!</div>
    <table class="table table-striped bg-white" v-if="documents.length">
      <thead>
      <tr>
        <th><strong> عنوان مستند </strong></th>
        <th><strong>فایل مستند</strong></th>
        <th style="width: 1vw;"><strong>عملیات </strong></th>
      </tr>
      </thead>
      <tbody>

      <tr class="bg-white" v-for="(item) in documents">
        <td>{{ item.title }}</td>
        <td>
          <a :href="`${this.download_url}/${item.file}`" target="_blank">مشاهده</a>
        </td>
        <td>
          <a @click.prevent="deleteMethodFile(item.id)" style="margin-right: 0.3vw;" href="#"><img
              class="table-delete-img" src="/img/delete.f9fc94bc.svg" alt="delete"></a>

        </td>
      </tr>
      </tbody>


    </table>
  </div>
  <div class="modal__error bg-white" style="z-index: 9699; width: 54vw;" v-show="importModal">
    <div class="d-flex flex-row justify-content-between">
      <p>درون ریزی</p>
      <p @click="importModal=!importModal">❌</p>
    </div>
    <div style="border: 1px solid #777; padding: 1vw; border-radius: 1vw">
      <input ref="fileInputTwo" type="file" class="form-control" style="display:block;"
             accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
      <div class="d-flex align-items-center justify-content-center">

      </div>
    </div>

  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="infoCancelled" style="z-index: 999999999999999; top: 40%;">
    <div>
      <p>عدم تایید</p>
      <p @click="infoCancelled=!infoCancelled">❌</p>
    </div>
    <div>
      <p>علت عدم تایید خود را بصورت کامل شرح دهید:</p>
      <textarea v-model="text_info" class="form-control" name="" id="" cols="30" rows="10"></textarea>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="infoCancelled=!infoCancelled" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="acceptComplete3">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="delete_fileModal" style="z-index: 999999999999999; top: 40%;">
    <div class="d-flex justify-content-between w-100">
      <p>حذف</p>
      <p @click="delete_fileModal=!delete_fileModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="delete_fileModal=!delete_fileModal" class="btn btn-primary btn-back" type="submit">برگشت
        </button>
        <button class="btn btn-primary btn-approve" @click="deleteMethodFileSubmit(id_file)">تایید</button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  components: {Vue3PersianDatetimePicker},
  data() {
    return {
      actionStatus: 'همه',
      activityStatus: 'تکمیل نشده',
      period: 'همه',
      events: [],
      status_loading2: false,
      importModal: false,
      delete_fileModal: false,
      documentsModal: false,
      MissionModal: false,
      KeyDefinitionsModal: false,
      allItems: [],
      documents: [],
      id: '',
      title: '',
      id_file: '',
      titleDoc: '',
      title_attach: '',
      file: '',
      id_two: '',

      target: '',

      title_task: '',
      trustee_device: '',
      partner_device: '',
      start_date_task: '',
      end_date_task: '',
      expected_progress: '',
      key_activities_problems_id: '',
      spring_progress: '',
      summer_progress: '',
      autumn_progress: '',
      winter_progress: '',
      progress: '',
      deviation: '',
      important_obstacles: '',
      approach: '',
      year_funds: '',
      spring_funds: '',
      summer_funds: '',
      autumn_funds: '',
      winter_funds: '',
      id_user: '',
      id_route: this.$route['params']['id'],
      status_show: false,
      banBySeconder: null,
      banByApprover: null,
      statusIsApproved: null,
      status_loading: false,
      infoCancelled: false,
      text_info: '',
      modalMessageShow: '',
      modalMessage: false,
      modalMessageShowModal: false,
      event: '',
      spring: false,
      summer: false,
      autumn: false,
      winter: false,
      step: 0,
    }
  },
  methods: {
    shouldShowTrusteeActions(index, item) {
      return index === 0 ||
          (this.allItems[index - 1] &&
              this.allItems[index - 1].propulsion_basic_action &&
              item.propulsion_basic_action &&
              this.allItems[index - 1].propulsion_basic_action.id !== item.propulsion_basic_action.id);
    },
    updateValue(result, newValue, type) {
      if (type === 'spring') {
        result.value_per_yes = newValue;
      } else if (type === 'summer') {
        result.value_second_per_yes = newValue;
      }

      // به روز رسانی توابع محاسبه
      this.calculateSpringProgress(result);
      this.calculateSummerProgress(result);
    },
    calculateSpringProgress(result) {
      if (result.nature_type === 2) {
        return parseFloat(result.value_per_yes / (result.goal_spring || 1)).toFixed(2);
      }
      return 0; // or handle other cases as needed
    },

    calculateSummerProgress(result) {
      if (result.nature_type === 2) {
        return parseFloat((result.value_second_per_yes || 0) / (result.goal_summer || 1)).toFixed(2);
      }
      return 0; // or handle other cases as needed
    },
    calculatedValueTwo(id, expected_progress_spring = 0) {
      let result = 0;
      const one = parseFloat(document.querySelector(`#inputTwo_${id}`).value);


      let calc = (expected_progress_spring ?? 0) - (isNaN(one) ? 0 : one);

      if (calc < 0) {
        result = 0;
      } else {
        result = calc;
      }

      // Format result to two decimal places
      document.querySelector(`#result_two_${id}`).textContent = Number(result).toFixed(2);
    },
    calculatedValue(id, expected_progress_spring = 0) {
      let result = 0;
      const one = parseFloat(document.querySelector(`#inputOne_${id}`).value);

      let calc = (expected_progress_spring ?? 0) - (isNaN(one) ? 0 : one);

      if (calc < 0) {
        result = 0;
      } else {
        result = calc;
      }

      // Ensure that the result is always a number before applying toFixed
      document.querySelector(`#result_one_${id}`).textContent = Number(result).toFixed(2);
    },
    deleteMethodFile(id) {
      this.id_file = id
      this.delete_fileModal = true
    },
    deleteMethodFileSubmit(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/remove_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            const message = response.message
            if (message) {
              toast.success(message)
              this.delete_fileModal = false
              this.id_file = ''
              this.allDocsMethod(response.id)

            }
          })
          .catch();
    },
    acceptComplete() {
      if (this.statusIsApproved) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      this.status_loading = true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading = false
              return
            }
            if (response.message) {
              this.banByApprover = false
              this.statusIsApproved = true
              toast.success(response.message)
              this.status_show = !this.status_show
              this.status_loading = false
              this.all()
              this.infoCancelled = false

            }

          })
          .catch();
    },
    acceptComplete2() {
      if (this.banByApprover) {
        return;
      }
      if (this.status_loading) {
        return;
      }
      if (!this.infoCancelled) {
        if (this.$cookies.isKey('type_1')) {
          if (this.status_show) {
            this.text_info = ''
            this.infoCancelled = true
            return;
          }
        }
      }
      this.infoCancelled = true


    },
    acceptComplete3() {
      this.status_loading2 = true
      if (!this.status_show) {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
        var formdata = new FormData();
        if (this.text_info) {
          formdata.append('text', this.text_info)
        }
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        };
        fetch(`${this.base_url}/KeyActivitiesProblem/update_complete_by_mother/${this.id_route}`, requestOptions)
            .then(response => response.json())
            .then(response => {
              this.all()
            })
            .catch();
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.text_info) {
        formdata.append('text', this.text_info)
      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/update_complete_by_mother/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              this.status_loading2 = false
              return
            }
            if (response.message) {
              this.banByApprover = true
              toast.success('کاربرگ توسط رئیس کمیته تایید نشد!')
              // this.status_show = !this.status_show
              this.status_show = false
              this.status_loading2 = false
              this.all()
            }
            this.infoCancelled = false

          })
          .catch();
    },
    importExcel() {
      const file = this.$refs.fileInputTwo.files[0]
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach)
      formdata.append('file', file)
      formdata.append('id', this.id)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/import`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.$refs.fileInputTwo.value = ''
            this.all()
            this.importModal = false

          })
          .catch();
    },
    allDocsMethod(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/total_doc/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            this.documents.length = 0
            response.all.forEach((item) => {
              this.documents.push(item)
            })


          })
          .catch();
    },
    addDocs() {
      const token = this.$cookies.get('token')
      const id_item = this.id
      const url = this.base_url
      const file = document.querySelector('#file').files[0];
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_attach);
      formdata.append('file', file);
      formdata.append('id', this.id);
      formdata.append('company_id', this.id_route);

      var xhr = new XMLHttpRequest();
      xhr.open('POST', `${this.base_url}/DeviceMonitoringCareForProblem/save_doc`, true);

      // Listen to the progress event
      xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
          document.getElementById("showBar").style.display = 'block';
          document.getElementById("btn2_p").style.visibility = 'hidden'
          document.getElementById("btn_p").style.visibility = 'hidden'
          var progress = ((event.loaded / event.total) * 100).toFixed();
          // Update progress UI here
          // For example:
          this.progress = progress
          document.getElementById("progress").innerText = `${progress}%`;
          document.getElementById("progress_bar").style.width = `${progress}%`;
        }
      };

      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // Handle successful upload
            var response = JSON.parse(xhr.responseText);
            if (response.error) {
              toast.error(response.error);
            } else {
              toast.success(response.message);
              file.value = '';
              this.title_attach = '';
              document.querySelector('#title').value = ''
              document.querySelector('#file').value = ''
              document.getElementById("showBar").style.display = 'none';
              document.getElementById("btn2_p").style.visibility = 'visible'
              document.getElementById("btn_p").style.visibility = 'visible'

            }
          } else {
            // Handle upload error
            console.error('Upload error:', xhr.status);
          }
        }
      };

      // Set headers
      for (var pair of myHeaders.entries()) {
        xhr.setRequestHeader(pair[0], pair[1]);
      }

      // Send the request with form data
      xhr.send(formdata);
      this.allDocsMethod(this.id);
      this.title_attach = '';

    },
    addDoc(title, id) {
      this.id = id
      this.titleDoc = title
      this.allDocsMethod(this.id)
      this.documentsModal = true
    },


    exportDocs() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id', this.id_route)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/DeviceMonitoringCareForProblem/export_doc`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.download_link) {
              // ایجاد یک المان a مخفی برای دانلود
              const link = document.createElement('a');
              link.href = response.download_link;
              link.download = 'documents.zip'; // یا هر نام دیگری که می‌خواهید
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              toast.info('دانلود شروع شد');
            } else if (response.error) {

              // نمایش پیام خطا به کاربر
              toast.error('خطا در دریافت فایل: ' + response.error);
            }
          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },


    all() {
      this.modalMessage = false

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('action_status', this.actionStatus)
      formdata.append('activity_status', this.activityStatus)
      formdata.append('period', this.period)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/KeyActivitiesProblem/all_monitoring_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }

            this.step = response.step

            this.statusIsApproved = response.status
            this.status_show = response.status

            this.banByApprover = response.approver_ban;
            this.banBySeconder = response.seconder_ban;

            this.allItems.length = 0
            response.all.forEach((item) => {

              this.allItems.push(item)

            })
            this.event = response.event
            if (response.message) {
              this.modalMessage = true
              this.modalMessageShow = response.message
            }
            if (response.setup) {
              this.spring = response.setup.spring
              this.summer = response.setup.summer
              this.autumn = response.setup.autumn
              this.winter = response.setup.winter
            }
            if (response.events) {
              this.events = response.events
            }
          })
          .catch();
    },
    store() {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('items', JSON.stringify(this.allItems))
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/KeyActivitiesProblem/store_monitoring_original`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.message) {
              toast.success(response.message)

            }

          })
          .catch(error => {
            toast.error('خطا در ارتباط با سرور. لطفا دوباره تلاش کنید.');
          });
    },
    fetchItems() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/show`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.logout()
              return;
            }
            if (result['item']) {
              if (this.is_mother) {
                this.id_user = result['item']['id']
                return;
              }
              this.id_user = result['item']['company_id']

            }

          })
          .catch();
    },
    calculateDeviation(progress, target) {
      progress = parseFloat(progress) || 0;
      target = parseFloat(target) || 0;
      const deviation = progress - target;
      return deviation > 0 ? deviation.toFixed(2) : '0';
    },
    updateItemDeviation(item) {
      item.deviation_spring = this.calculateDeviation(item.progress_spring, item.target_spring);
      item.deviation_summer = this.calculateDeviation(item.progress_summer, item.target_summer);
      item.deviation_autumn = this.calculateDeviation(item.progress_autumn, item.target_autumn);
      item.deviation_winter = this.calculateDeviation(item.progress_winter, item.target_winter);
    },
  },
  watch: {
    allItems: {
      deep: true,
      handler(newItems) {
        newItems.forEach(this.updateItemDeviation);
      }
    },
    actionStatus: function () {
      this.all();
    },
    activityStatus: function () {
      this.all();
    },
    period: function () {
      this.all();
    },
  },
  mounted() {
    this.all()
    this.fetchItems()
  }
}
</script>
<style scoped>
.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}

.input:hover .input__support {
  border-color: #9fa8b2;
}

.input:hover .input__support:before {
  color: #7d8a96;
}

.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}

.input__text sup {
  color: #fe4f3e;
  cursor: help;
}

.input .input__support:before {
  display: none;

}

.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__field:focus + .input__support {
  border-color: #037DE4;
}

.input__field:valid + .input__support {
  border-color: #3742FA;
}

.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}

.input__field:valid + .input__support .input__helper:before {
  content: "یک فایل انتخاب شده است";
  color: #7d8a96;
}

.input__field:invalid + .input__support:before {
  content: "file_upload";
}

.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}

.input__support {
  display: flex !important;
  align-items: center;
}

.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}

.input--file {
  cursor: pointer;
}

.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}

.input {
  display: block;
  margin-bottom: 1.5em;
  min-width: 10em;
}

.input:hover .input__support {
  border-color: #9fa8b2;
}

.input:hover .input__support:before {
  color: #7d8a96;
}

.input__text {
  display: block;
  padding-bottom: 0.5em;
  margin-left: 0.18em;
}

.input__text sup {
  color: #fe4f3e;
  cursor: help;
}

.input .input__support:before {
  display: none;

}

.input .input__support, .input .input__field {
  border-radius: 0;
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  line-height: 1.25;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #c1c7cd;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__field:focus + .input__support {
  border-color: #037DE4;
}

.input__field:valid + .input__support {
  border-color: #3742FA;
}

.input__field:valid + .input__support:before {
  content: "done";
  color: #3742FA;
}

.input__field:valid + .input__support .input__helper:before {
  content: "یک فایل انتخاب شده است";
  color: #7d8a96;
}

.input__field:invalid + .input__support:before {
  content: "file_upload";
}

.input__field:invalid + .input__support .input__helper:before {
  content: "انتخاب فایل (فرمت های قابل قبول: ورد-پی دی اف - اکسل-تصاویر)";
}

.input__support {
  display: flex !important;
  align-items: center;
}

.input__support:before {
  content: "file_upload";
  display: inline-block;
  color: #9fa8b2;
  width: 1.2rem;
  height: 1.2rem;
  margin: -0.5rem 0.5rem -0.5rem -0.2rem;
  transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input__helper:before {
  font-weight: 200;
  color: #9fa8b2;
  content: "Select file";
}

.input--file {
  cursor: pointer;
}

.input--file input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  padding: 0;
}

.changer {
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 20vw;
  justify-content: space-evenly;

  & > p:nth-child(1) {
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }

  & > p {
    margin-left: 1vw;
  }

  & > p {
    cursor: pointer;
    font-size: 1vw;
  }

  & > a {
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}

p {
  font-size: 1vw;
}

.changer_btn {
  display: flex;
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 17vw;
  justify-content: space-evenly;
  align-items: center; /* برای تراز عمودی */
}

.changer_btn > p {
  transform: translateY(0.7vw);
  cursor: pointer; /* نشانگر ماوس تغییر کند */
  transition: all 0.3s ease; /* انیمیشن نرم */
  padding: 0; /* حذف فاصله اضافی */
}

.changer_btn > p.active,
.changer_btn > p.active_two {
  color: #fff;
  background-color: #3742FA;
  height: 2vw;
  border-radius: 1vw;
  transform: translateY(0.7vw);

}

.changer_btn > p.active {
  width: 11vw;
  transform: translateX(1.9vw) translateY(0.6vw);
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}

th.sticky-column, td.sticky-column {
  position: sticky;
  right: -.05vw;
  z-index: 3;
  box-shadow: inset .4vw 0 .4vw -.4vw rgba(255, 255, 255, 0.4);
}

th.sticky-column {
  background-color: #3742FA;
  z-index: 4;
}

td.sticky-column {
  background-color: #fff;
}

th.sticky-column-two, td.sticky-column-two {
  right: 23.8vw;
}

th.sticky-column-three, td.sticky-column-three {
  right: 30.6vw;
}

.filter-container {
  padding: 0 10vw;
}
</style>
